import { randomUUID } from "node:crypto";

export function createJobId(prefix = "job"): string {
  return `${prefix}_${randomUUID()}`;
}
